import React from 'react';

import NavBar from "../components/NavBar";
import PricingComponent from "../components/Pricing";
import Footer from "../components/Footer";

const Pricing = () => {
   return (
    <>
    <NavBar/>
    <PricingComponent/>
    <Footer/>
   </>
   )
}

export default Pricing;
